import { Download as DownloadIcon } from "@mui/icons-material";
import { Button, Link } from "@mui/material";

import { useMemo } from "react";
import Helpers from "../../commons/helpers";
import { IAssetInfo } from "../../commons/interfaces";
import { ASSET_API_URL, Constants } from "../../constants/constants";
import useStrings from "../../hooks/useStrings";
import Box from "../Box";
import Modal from "../Modal";
import VideoPlayer from "../VideoPlayer";

interface IPreviewFileDialog {
    visibled: boolean;
    // fileId: string;
    onClose: () => void;
    assetInfo: IAssetInfo;
}

const PreviewFileDialog = ({ assetInfo, visibled, onClose }: IPreviewFileDialog) => {
    const strings = useStrings();

    // const [assetInfo, setAssetInfo] = useState<IAssetInfo>({
    //     isDocument: false,
    //     isVideo: false,
    //     isImage: false,
    // } as IAssetInfo);

    // useEffect(() => {
    //     const getInfo = async () => {
    //         if (Helpers.isNullOrEmpty(fileId)) return setAssetInfo({ isDocument: false, isVideo: false, isImage: false } as IAssetInfo);
    //         const result = await AssetService.getAssetInfo(fileId);
    //         return setAssetInfo(result);
    //     };
    //     getInfo();
    //     return () => {
    //         setAssetInfo({
    //             isDocument: false,
    //             isVideo: false,
    //             isImage: false,
    //         } as IAssetInfo);
    //     };
    // }, [visibled]);

    // if (Helpers.isNullOrEmpty(fileId)) {
    //     return <></>;
    // }

    const title = useMemo(() => {
        const result: string[] = [];
        if (assetInfo.isImage) result.push(strings.Common.IMAGE);
        if (assetInfo.isDocument) result.push(strings.Common.DOCUMENT);
        if (assetInfo.isVideo) result.push(strings.Common.VIDEO);
        result.push(!Helpers.isNullOrEmpty(assetInfo.fileName) ? assetInfo.fileName : "");
        return result.join(": ");
    }, [assetInfo?.isDocument, assetInfo?.isImage, assetInfo?.isVideo, assetInfo?.fileName]);

    return (
        <Modal title={title} visible={visibled} onClose={onClose} maxWidth="lg">
            {assetInfo.isImage && !Helpers.isNullOrEmpty(assetInfo.accessUrl) && assetInfo.id === "0" && (
                <img
                    alt="preview"
                    loading="lazy"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    src={assetInfo.accessUrl}
                />
            )}
            {assetInfo.isImage && assetInfo.id !== "0" && (
                <img
                    alt="preview"
                    loading="lazy"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    src={Helpers.getFileAccessUrl(assetInfo.id)}
                />
            )}

            {assetInfo.isVideo && <VideoPlayer fileId={assetInfo.id} />}

            {assetInfo.isDocument && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        border: "3px dashed #c3c3c3",
                        padding: "1rem 2rem",
                        width: "min(400px, 70vw)",
                    }}
                >
                    <DownloadIcon sx={{ width: "100px", height: "100px" }} />
                    <Button
                        download
                        component={Link}
                        target={"_blank"}
                        style={{ fontSize: 16 }}
                        href={
                            Helpers.isNullOrEmpty(assetInfo.id) || assetInfo.id === "0"
                                ? ""
                                : ASSET_API_URL + Constants.ApiPath.ASSET.GET_ASSET_DOWNLOAD_URL + `/${assetInfo.id}`
                        }
                    >
                        {strings.Common.DOWNLOAD}
                    </Button>
                </Box>
            )}
        </Modal>
    );
};

export default PreviewFileDialog;
